// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"f344ed78","75":"fc19ab9c","379":"8490e7c4","442":"72d3e1fc","488":"e74645e2","501":"7eb3c093","540":"fa1b4d9a","641":"bee26b2e","654":"4e2c8c3a","655":"59e7be0a","737":"57448440","742":"bdbdbda3","818":"124a62b0"}[chunkId] + ".chunk.js";
};